exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".newprogram[data-v-b72c83c2]{margin-bottom:18px;display:-ms-grid;display:grid;gap:18px}@media only screen and (min-width:570px){.newprogram[data-v-b72c83c2]{-ms-grid-columns:(minmax(200px,1fr))[2];grid-template-columns:repeat(2,minmax(200px,1fr))}}@media only screen and (min-width:760px){.newprogram[data-v-b72c83c2]{margin-bottom:36px;gap:18px 36px}}.newprogram[data-v-b72c83c2] .wide{grid-column:1/-1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b72c83c2","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/newprogram/components/form/Form.vue
// module id = 453b90259b7cdff26fb2
// module chunks = 10